<template>
  <div>
    <PageAllow controller="Settlements" action="purchaseBillView"/>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ settlement ? settlement.name : '' }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="settlement.status | settlementStatusColor"
                :text-color="settlement.status | settlementStatusTextColor"
                >{{ settlement.status | settlementStatusText }}
              </v-chip>
              <v-chip
                v-if="settlement.edit_status == 1"
                small
                label
                class="ms-4 mt-1"
                color="warning"
                text-color="white"
              >
                {{ $t("SettlementsPurchase.status.editing") }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="$permission.permissionAllow('Settlements', 'purchaseDetailExport')"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="download(settlement.id)"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("Receipt.bill_details_export") }}
                </v-btn>
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.settlement_code") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.settlement_code ? settlement.settlement_code : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.receive_settlement") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.receive_entity_name ? settlement.receive_entity_name : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.pay_settlement") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement && settlement.pay_entity_name ? settlement.pay_entity_name : "" }}
                  </span>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ settlement ? settlement.created : "" | formatTime }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.fee") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.fee : "", true) }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.paid") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.paid : "", true) }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("SettlementsPurchase.Fields.wait_receive") }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}{{ $numberFormatter.formatMoneyFloor(settlement ? settlement.wait_receive : "", true) }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0; panels.find((p) => p == 1) ? null : panels.push(1);">
                {{ $t("SettlementsShop.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="order_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card class="mt-4">
        <v-card-title>
          {{ $t("PurchaseBillView.title") }}
        </v-card-title>
        <!-- 明细/编辑 -->
        <v-data-table
          :headers="detailsHeaders"
          :items="settlementBills"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          disable-sort
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color" align-self="center">
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{ $t("$vuetify.dataFooter.pageText", paging ? [1, paging.current, paging.count,] : [0, 0, 0]) }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="6" md="4">
                    <SearcherKeyword
                      v-model="options.keyword"
                      @text="filter = $event"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <!-- 合计 -->
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td>
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td colspan="3"></td>
              <td>{{ $t("Global.money") }}{{ totalFee | formatMoneyFloor(true) }}</td>
              <td colspan="3"></td>
            </tr>
          </template>
          <template v-slot:item.fee="{ item }">
            {{ $t("Global.money") }}{{ item.fee | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.logistics_fee="{ item }">
            {{ $t("Global.money") }}{{ item.logistics_fee | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.service_charge="{ item }">
            {{ $t("Global.money") }}{{ item.service_charge | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.order_discount="{ item }">
            {{ $t("Global.money") }}{{ item.order_discount | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="$permission.permissionAllow('Settlements', 'detailByBill')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentBill = item;
                    detailDialog = true;
                  "
                >
                  {{ $t("ShopBillView.Fields.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("ShopBillView.Fields.detail") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="$permission.permissionAllow('Settlements', 'getBillRelatedImg')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    currentBill = item;
                    imgDialog = true;
                  "
                >
                  {{ $t("ShopBillView.Fields.img") }}
                </v-btn>
              </template>
              <span>{{ $t("ShopBillView.Fields.img") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-sheet>
    <SettlementBillDialog v-model="detailDialog" :currentItem="currentBill" :type="settlement.type" />
    <SettlementImagesDialog v-model="imgDialog" :currentItem="currentBill" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Settlements from "@/api/settlements";
import SettlementBillDialog from "@/components/plugins/SettlementBillDialog";
import SettlementImagesDialog from "@/components/plugins/SettlementImagesDialog";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  components: {
    SearcherKeyword,
    SettlementImagesDialog,
    PageAllow,
    Breadcrumbs,
    SettlementBillDialog,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.settlements"),
          disabled: false,
          href: "/settlements-purchase",
        },
        {
          text: i18n.t("Nav.settlementsPurchase"),
          disabled: false,
          href: "/settlements-purchase",
        },
        {
          text: i18n.t("PurchaseBillView.title"),
          disabled: true,
          href: "/settlements-purchase",
        },
      ];
      return items;
    },
    detailsHeaders() {
      let headers = [];
      headers.push(
        {
          text: i18n.t("PurchaseBillView.Fields.bill_code"),
          align: "start",
          value: "bill_code",
        },

        {
          text: i18n.t("PurchaseBillView.Fields.logistics_fee"),
          align: "start",
          value: "logistics_fee",
        },
        {
          text: i18n.t("PurchaseBillView.Fields.service_charge"),
          align: "start",
          value: "service_charge",
        },
        {
          text: i18n.t("PurchaseBillView.Fields.order_discount"),
          align: "start",
          value: "order_discount",
        },
        {
          text: i18n.t("PurchaseBillView.Fields.fee"),
          align: "start",
          value: "fee",
        },
        {
          text: i18n.t("PurchaseBillView.Fields.org_code"),
          align: "start",
          value: "org_code",
        },
        {
          text: i18n.t("PurchaseBillView.Fields.bill_created"),
          align: "start",
          value: "bill_created",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      );
      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("SettlementsShop.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("SettlementsShop.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("SettlementsShop.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    options: {},
    paging: {},
    settlement: [],
    settlementBills: [],
    detailDialog: false,
    imgDialog: false,
    currentBill: null,
    totalFee: 0,
    order_activities: [],
    tab: null,
    filter: '',
  }),

  mounted() {
    this.getSettlementsPurchaseBillsFromAPI()
    this.getBillListForPaginate();
  },

  methods: {
    getSettlementsPurchaseBillsFromAPI() {
      Settlements.fetchPurchaseBill(this.$route.params.id, {order_activity: 1}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settlement = response.data.settlement;
            this.order_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    getBillListForPaginate() {
      let postData = Object.assign({}, this.options, {
        id: this.$route.params.id
      });
      Settlements.getBillListForPaginate(postData).then(
        function (response) {
          this.totalFee = response.data.total_fee
          this.settlementBills = response.data.settlement_bills
          this.paging = response.data.paging
        }.bind(this)
      )
    },
    download(id) {
      Settlements.purchaseDetailExport(id);
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getBillListForPaginate();
      },
    },
  },
};
</script>